import { ReviewTileItem } from "@/types/tile.types";

const getFieldText = (label: string, value: any): string => {
  if (value === undefined || value === null || value === "") return "";

  let stringValue: string;
  if (typeof value === "object") {
    stringValue = JSON.stringify(value, null, 2);
  } else {
    stringValue = String(value);
  }

  return `${label}: ${stringValue}\n`;
};

export const getTileContentAsText = (tile: ReviewTileItem): string => {
  const item = tile.originalData;
  const tileType = tile.originalKey;
  let content = "";

  if (item.documentName) {
    content += getFieldText("Document Name", item.documentName);
  }

  switch (tileType) {
    case "riskPoints":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Risk Text", item.riskText);
      content += getFieldText("Risk Explanation", item.riskExplanation);
      content += getFieldText("Suggestion", item.suggestions);
      break;
    case "ambiguities":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Ambiguous Text", item.ambiguousText);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "conflictingTerms":
      content += getFieldText("Clause Number", item.clause1?.number);
      content += getFieldText("Clause Number", item.clause2?.number);
      content += getFieldText("Relevant Text", item.clause1?.relevant_text);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "complexLanguage":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Complex Text", item.complexText);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestions", item.suggestions);
      break;
    case "negotiationPoints":
      if (item.email) {
        content += getFieldText("Email", item.email);
      } else {
        content += getFieldText("Clause", item.clause);
        content += getFieldText("Negotiation Text", item.negotiationText);
        content += getFieldText("Points", item.points);
        content += getFieldText("Suggestion", item.suggestion);
      }
      break;
    case "nonStandardClauses":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Non-Standard Text", item.nonStandardText);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "undefinedTerms":
      content += getFieldText("Context", item.contextText);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "placeholders":
      content += getFieldText("Placeholder", item.placeholder);
      break;
    case "crossReferencingClauses":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Context", item.context);
      content += getFieldText("Suggestion", item.suggestion);
      break;
    case "sequentialOrder":
      content += getFieldText("Current Number", item.currentNumber);
      content += getFieldText("Context", item.context);
      content += getFieldText("Suggested Number", item.suggestedNumber);
      content += getFieldText("Reason", item.reason);
      break;
    case "missingClauses":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestedclause);
      content += getFieldText("Insertion Point Under", item.insertionPoint);
      break;
    case "inconsistencies":
      if (item.document1 && item.document2) {
        content += getFieldText("Document 1", item.document1);
        content += getFieldText("Document 2", item.document2);
      }
      content += getFieldText("Text 1", item.text1);
      content += getFieldText("Text 2", item.text2);
      content += getFieldText("Explanation", item.explanation);
      content += getFieldText("Suggestion", item.suggestion);
      break;
    case "customReview":
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Relevant Text", item.relevantText);
      content += getFieldText("Reason", item.reason);
      content += getFieldText("Suggestion", item.suggestion);
      break;
    case "compare_precedent_additional_clauses":
      content += getFieldText("Info", item.info);
      content += getFieldText("Clause Number", item.clauseNumber);
      content += getFieldText("Additional Clause", item.additionalClause);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "compare_precedent_general_comparison":
      content += getFieldText("Precedent Text", item.precedentText);
      content += getFieldText("Other Text", item.otherText);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "compare_precedent_missing_clauses":
      content += getFieldText("Info", item.info);
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Missing Clause", item.missingClause);
      content += getFieldText("Other Text", item.otherText);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "compare_precedent_unfavorable_terms":
      content += getFieldText("Info", item.info);
      content += getFieldText("Precedent Text", item.precedentText);
      content += getFieldText("Other Text", item.otherText);
      content += getFieldText("Analysis", item.analysis);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "compare_precedent_legislation_check":
      content += getFieldText("Compliance Impact", item.complianceImpact);
      content += getFieldText("Precedent Text", item.precedentText);
      content += getFieldText("Legislation Text", item.legislationText);
      content += getFieldText("Analysis", item.analysis);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    case "compare_precedent_inconsistencies":
      content += getFieldText("Info", item.info);
      content += getFieldText("Clause", item.clause);
      content += getFieldText("Precedent Text", item.precedentText);
      content += getFieldText("Other Text", item.otherText);
      content += getFieldText("Explanation", item.explanation);
      content += getFieldText("Suggestion", item.suggestedclause);
      break;
    default:
      content += item.reason || item.analysis || item.explanation || "No content available";
      break;
  }

  return content.trim();
};
